import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removeTile } from "@/services/review.service";
import type { RemoveTileRequest } from "@/types/review.types";

export interface UseRemoveTileOptions {
  onSuccess?: (message: string) => void;
  onError?: (error: string) => void;
}

export const useRemoveTile = (options?: UseRemoveTileOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: RemoveTileRequest) => removeTile(request),
    onSuccess: () => {
      // Invalidate relevant queries to refresh data
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
      queryClient.invalidateQueries({ queryKey: ["storedResponse"] });

      options?.onSuccess?.("Tile removed successfully");
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || error?.message || "Failed to remove tile";
      options?.onError?.(errorMessage);
    },
  });
};
